import { MessageType, MessagesSet, DoctorEntity, QuestionEntity, OfflineFormMessage, SelfConsultFormMessage, MedicalFormMessage, FormOrderMessage } from '@tencent/dz-models';
import { isElementInViewport } from 'src/utils';

export class ContentExposure {
  private queue: MessagesSet[] = [];
  private elementList: any[] = [];
  private typeMap: any = {
    [MessageType.Server]: 'message', // 客服消息，主要针对一键电话卡
    [MessageType.QuestionRecommen]: 'guess_question',
    [MessageType.HospitalCard]: 'card_hospital',
    [MessageType.DiseaseCard]: 'card_disease',
    [MessageType.ActivityCard]: 'card_activity',
    [MessageType.QuickPhoneForm]: 'offline_message',
    [MessageType.MedicaleForm]: 'form',
    [MessageType.SelfConsultForm]: 'form',
    [MessageType.DoctorCard]: 'card_doctor',
    [MessageType.OfflineForm]: 'form',
    [MessageType.FormOrder]: 'form',
    [MessageType.SearchTerm]: 'card_queryword_preinput',
  };

  updateContentQueue(updatedQueue: MessagesSet[]) {
    this.queue = updatedQueue;
  };

  getElementsInViewport() {
    this.elementList = [];
    // 需要上报的队列
    const needReportQueue = this.queue.filter((val) => {
      const { type, payload: { recommend } } = val;
      if (type === MessageType.Server) {
        return !!recommend?.showSendPhoneNumberCard;
      }
      return this.typeMap[type];
    });

    needReportQueue.forEach((val) => {
      const moduleType = this.typeMap[val.type];
      const { payload } = val;
      switch (val.type) {
        case MessageType.Server:
        case MessageType.QuickPhoneForm:
          // 处理离线消息
          this.handleSingleEleAdd(`#${moduleType}`, {
            module_value: val.msg_content || '',
            module_type: moduleType,
            element_type: 'quick_send_phone',
          });
          break;
        case MessageType.QuestionRecommen:
          // 猜你想问
          this.handleSingleEleAdd(`#${moduleType}`, {
            module_id: '',
            module_value: payload.message.map((item: QuestionEntity) => item.question).join(','),
            module_type: 'guess_question',
            element_type: 'guess_question',
          });
          // 猜你想问顶部
          this.handleSingleEleAdd(`#${moduleType}_top`, {
            module_id: '',
            module_value: payload.message.map((item: QuestionEntity) => item.question).join(','),
            module_type: 'guess_question_top',
            element_type: 'guess_question',
          });
          break;
        case MessageType.ActivityCard:
        case MessageType.DiseaseCard:
        case MessageType.HospitalCard:
          // 卡片信息处理
          this.handleSingleEleAdd(`#card_${payload.content.id}`, {
            module_id: payload.content.id,
            module_value: payload.content.name,
            module_type: moduleType,
          });
          break;
        case MessageType.MedicaleForm:
        case MessageType.SelfConsultForm:
        case MessageType.OfflineForm:
        case MessageType.FormOrder:
          this.handleFormExposure(val);
          break;
        case MessageType.DoctorCard:
          // 卡片信息处理
          payload.content.forEach((doctor: DoctorEntity) => {
            this.handleSingleEleAdd(`#card_${doctor.id}`, {
              module_id: doctor.id,
              module_value: doctor.name,
              module_type: moduleType,
            });
          });
          break;
        case MessageType.SearchTerm:
          // 搜索词预输入
          this.handleSingleEleAdd(`#${moduleType}`, {
            module_type: 'card_queryword_preinput',
            element_type: 'card_queryword_preinput',
            element_content: payload.message.slice(4),
          });
          break;
        default:
          break;
      }
    });
    return this.elementList;
  };

  handleSingleEleAdd(selector: string, value: any) {
    const ele = document.querySelector(selector);
    this.handleAdd(ele, value);
  };

  handleMultipleEleAdd(selector: string, value: any) {
    const eleList = document.querySelectorAll(selector) || [];
    eleList.forEach((ele) => {
      this.handleAdd(ele, value);
    });
  };

  handleAdd(ele: any, value: any) {
    const { module_id = '', module_value = '', module_type, element_type, element_content = '' } = value;
    if (isElementInViewport(ele)) {
      this.elementList.push({
        module_id,
        module_value,
        module_type,
        element_type: element_type || module_type,
        element_content,
      });
    }
  };

  handleFormExposure(val: OfflineFormMessage | SelfConsultFormMessage | MedicalFormMessage | FormOrderMessage) {
    const { reportModuleParams } = val.payload;
    // 处理表单， 表单可能存在展示多个的情况，所以用querySelectorAll获取元素
    const { module_type, module_id } = reportModuleParams;
    const elementType = 'form';
    if (module_type === 'quick_consult') {
      // 表单点击来源是 自助咨询 的
      this.handleMultipleEleAdd('.from_quick_consult', { ...reportModuleParams, element_type: elementType });
    } else {
      this.handleMultipleEleAdd(`.source_id_${module_id}`, { ...reportModuleParams, element_type: elementType });
    }
  };
}

const contentExposure = new ContentExposure();
window.contentExposure = contentExposure;
export default contentExposure;
